import React from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';

interface DNSRecordListHeaderProps {
  recordCount: number;
  selectedIds: string[];
  allSelected: boolean;
  onToggleSelectAll: () => void;
  onBulkDeleteClick: () => void;
  onAddRecord: () => void;
  bulkTTL: string;
  setBulkTTL: (value: string) => void;
  onBulkTTLUpdate: () => void;
}

const DNSRecordListHeader: React.FC<DNSRecordListHeaderProps> = ({
  recordCount,
  selectedIds,
  allSelected,
  onToggleSelectAll,
  onBulkDeleteClick,
  onAddRecord,
  bulkTTL,
  setBulkTTL,
  onBulkTTLUpdate,
}) => {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center space-x-3">
        <h3 className="text-heading-2 text-slate-900 dark:text-white">DNS Records</h3>
        {recordCount > 0 && (
          <label className="inline-flex items-center space-x-2 text-sm text-slate-600 dark:text-slate-400">
            <input type="checkbox" checked={allSelected} onChange={onToggleSelectAll} />
            <span>Select all</span>
          </label>
        )}
        {selectedIds.length > 0 && (
          <div className="inline-flex items-center space-x-2">
            <span className="text-sm text-slate-600 dark:text-slate-400">
              {selectedIds.length} selected
            </span>
            <button className="inline-flex items-center justify-center px-4 py-2 text-white bg-red-600 hover:bg-red-700 focus:ring-2 focus:ring-red-500 focus:ring-offset-2 font-medium rounded-lg transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed text-xs" onClick={onBulkDeleteClick}>
              Bulk Delete
            </button>
            <div className="flex items-center space-x-1">
              <input
                className="input text-xs w-24"
                type="number"
                inputMode="numeric"
                min={1}
                step={1}
                placeholder="TTL"
                value={bulkTTL ?? ''}
                onChange={(e) => setBulkTTL(e.target.value || '')}
              />
              <button
                className="inline-flex items-center justify-center px-4 py-2 text-slate-700 bg-white border border-slate-200 hover:bg-slate-50 hover:border-slate-300 focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 font-medium rounded-lg transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed text-xs"
                onClick={onBulkTTLUpdate}
                disabled={
                  selectedIds.length === 0 ||
                  !bulkTTL ||
                  isNaN(parseInt(bulkTTL, 10)) ||
                  parseInt(bulkTTL, 10) < 1
                }
                title={
                  selectedIds.length === 0
                    ? 'Select records first'
                    : !bulkTTL ||
                      isNaN(parseInt(bulkTTL, 10)) ||
                      parseInt(bulkTTL, 10) < 1
                    ? 'Enter a valid TTL (>=1)'
                    : 'Apply TTL to selected records'
                }
              >
                Bulk TTL
              </button>
            </div>
          </div>
        )}
      </div>
      <motion.button
        className="inline-flex items-center justify-center px-4 py-2 text-slate-700 bg-white border border-slate-200 hover:bg-slate-50 hover:border-slate-300 focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 font-medium rounded-lg transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed text-xs"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={onAddRecord}
      >
        <Plus className="w-3 h-3 mr-1" />
        Add Record
      </motion.button>
    </div>
  );
};

export default DNSRecordListHeader;